import { useDeleteDocumentsFromProjectMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useDeleteDocumentsFromProject = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useDeleteDocumentsFromProjectMutation(headerWithAuth, options);

  return mutate;
};

export {
  useDeleteDocumentsFromProject,
};
